import { render, staticRenderFns } from "./SlugInput.vue?vue&type=template&id=2230f608&"
import script from "./SlugInput.vue?vue&type=script&lang=ts&"
export * from "./SlugInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports